import React, { Fragment } from 'react';
import { Table, Button, Popup, Icon, Grid } from 'semantic-ui-react';
import SearchTableData from '../../util/SearchTableData';
import ReactExport from 'react-data-export';
import { checkWritePrivilege } from '../util/util';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

const VehiclesTable = ({
    allVehicles,
    filteredVehicles,
    activateEditRequest,
    disableAction,
    deletingRowId,
    saving,
    handleDeleteClick,
    handleConfirmClick,
    handleCancelClick,
    excelData,
    getResults,
    handleSearchTextChange,
    searchFields,
}) => (
    <Table celled selectable sortable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell colSpan={checkWritePrivilege() ? 14 : 13}>
                    <Grid stackable verticalAlign="middle">
                        <Grid.Column width={14}>
                            <SearchTableData
                                profMozilla
                                data={allVehicles}
                                getResults={getResults}
                                filterItem={searchFields}
                                onSearchTextChange={handleSearchTextChange}
                            />
                        </Grid.Column>
                        <Grid.Column width={2} textAlign="right">
                            <ExcelFile filename="Vozila" element={<Popup
                                trigger={<Button animated="vertical" color="green" basic
                                                 floated="right" fluid
                                                 style={{ textAlign: 'center' }}>
                                    <Button.Content hidden><Icon name="download"/></Button.Content>
                                    <Button.Content visible>
                                        Excel
                                    </Button.Content>
                                </Button>}
                                content="Preuzmi Excel"
                                hideOnScroll
                                position="top center"
                            />}>
                                <ExcelSheet dataSet={sanitizeExcelDataSet(excelData)} name="Vozila"/>
                            </ExcelFile>
                        </Grid.Column>
                    </Grid>
                </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
                <Table.HeaderCell colSpan={1}>R. br.</Table.HeaderCell>
                <Table.HeaderCell colSpan={2}>Članica</Table.HeaderCell>
                <Table.HeaderCell colSpan={2}>Proizvođač
                    <div style={{
                        fontSize: '0.85em',
                        color: '#999'
                    }}>Model / Tip</div>
                </Table.HeaderCell>
                <Table.HeaderCell colSpan={2}>Tablice
                    <div style={{
                        fontSize: '0.85em',
                        color: '#999'
                    }}>Broj šasije</div>
                </Table.HeaderCell>
                <Table.HeaderCell colSpan={2}>Tip goriva
                    <div style={{
                        fontSize: '0.85em',
                        color: '#999'
                    }}>Broj sjedišta</div>
                </Table.HeaderCell>
                <Table.HeaderCell colSpan={2}>Godina proizvodnje
                    <div style={{
                        fontSize: '0.85em',
                        color: '#999'
                    }}>Godina nabavke</div>
                </Table.HeaderCell>
                <Table.HeaderCell colSpan={2}>Status
                    <div style={{
                        fontSize: '0.85em',
                        color: '#999'
                    }}>Vrijednost (BAM)</div>
                </Table.HeaderCell>
                {checkWritePrivilege() && <Table.HeaderCell colSpan={1}></Table.HeaderCell>}
            </Table.Row>
        </Table.Header>

        <Table.Body>
            {filteredVehicles.map((el, index) =>
                (
                    <Table.Row key={el.id}>
                        <Table.Cell verticalAlign="middle">{index + 1}.</Table.Cell>
                        <Table.Cell verticalAlign="middle"
                                    colSpan={2}>{el.organizationalUnit && el.organizationalUnit.name}</Table.Cell>
                        <Table.Cell verticalAlign="middle" colSpan={2}>
                            <div>{!!el.manufacturer && el.manufacturer.name}</div>
                            <div style={{
                                fontSize: '0.85em',
                                color: '#999'
                            }}>
                                {el.model || '-'} / {!!el.type && el.type.name}
                            </div>
                        </Table.Cell>
                        <Table.Cell verticalAlign="middle" colSpan={2}>
                            <div>{el.licencePlate}</div>
                            <div style={{
                                fontSize: '0.85em',
                                color: '#999'
                            }}>
                                {el.chassisNumber}
                            </div>
                        </Table.Cell>
                        <Table.Cell verticalAlign="middle" colSpan={2}>
                            <div>{!!el.fuelType && el.fuelType.name}</div>
                            <div style={{
                                fontSize: '0.85em',
                                color: '#999'
                            }}>
                                {el.numberOfSeats}
                            </div>
                        </Table.Cell>
                        <Table.Cell verticalAlign="middle" colSpan={2}>
                            <div>{el.productionYear || '-'}</div>
                            <div style={{
                                fontSize: '0.85em',
                                color: '#999'
                            }}>
                                {el.purchaseYear}
                            </div>
                        </Table.Cell>
                        <Table.Cell verticalAlign="middle" colSpan={2}>
                            <div>{!!el.status && el.status.name}</div>
                            <div style={{
                                fontSize: '0.85em',
                                color: '#999'
                            }}>
                                {el.value != null ? el.value + ' BAM' : '-'}
                            </div>
                        </Table.Cell>
                        {checkWritePrivilege() &&
                            <Table.Cell verticalAlign="middle" className="text-center">
                                {deletingRowId === el.id
                                    ?
                                    <Fragment>
                                        <Popup
                                            content="Potvrdi"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    circular
                                                    icon
                                                    size="tiny"
                                                    color="blue"
                                                    onClick={handleConfirmClick}
                                                    disabled={saving}
                                                    loading={saving}
                                                >
                                                    <Icon name="check"/>
                                                </Button>
                                            }
                                        />
                                        <Popup
                                            content="Otkaži"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic
                                                    circular
                                                    icon
                                                    size="tiny"
                                                    color="blue"
                                                    onClick={handleCancelClick}
                                                    disabled={saving}
                                                >
                                                    <Icon name="close"/>
                                                </Button>
                                            }
                                        />
                                    </Fragment>
                                    :
                                    <Fragment>
                                        <Popup
                                            content="Izmjena"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    disabled={disableAction || deletingRowId}
                                                    basic="true"
                                                    circular
                                                    icon="pencil"
                                                    size="tiny"
                                                    color="green"
                                                    onClick={() => {
                                                        activateEditRequest(el);
                                                    }}
                                                />

                                            }
                                        />
                                        <Popup
                                            content="Brisanje"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    disabled={disableAction || (deletingRowId && deletingRowId !== el.id)}
                                                    basic="true"
                                                    circular
                                                    icon="trash alternate"
                                                    size="tiny"
                                                    color="red"
                                                    onClick={() => {
                                                        handleDeleteClick(el.id);
                                                    }}
                                                />
                                            }
                                        />
                                    </Fragment>
                                }
                            </Table.Cell>
                        }
                    </Table.Row>
                ))
            }
        </Table.Body>
    </Table>);

export default VehiclesTable;



// WEBPACK FOOTER //
// ./src/views/Assets/Vehicles/VehiclesTable.js